module.exports = __webpack_public_path__ + "static/media/The_Beginning.de62b44d.gif";